import StatisticsReportCard, {
  StatisticsReportCardSkeleton,
} from "@/admin/dashboard/components/StatisticsReportCard"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import DiscoStatisticsTag from "@disco-ui/tag/statistics/DiscoStatisticsTag"
import { TestIDProps } from "@utils/typeUtils"

interface Props extends TestIDProps {
  value: string | number | React.ReactNode
  sinceYesterday?: number
  subtitle: string
  tooltip: string
}

export default function MemberReportStatisticCard({
  testid,
  value,
  sinceYesterday,
  subtitle,
  tooltip,
}: Props) {
  const classes = useStyles()
  return (
    <StatisticsReportCard
      key={subtitle}
      classes={{ root: classes.card }}
      tagVariant={"round"}
      testid={testid}
      value={value}
      tags={
        sinceYesterday ? (
          <DiscoStatisticsTag number={sinceYesterday} tagVariant={"round"} />
        ) : undefined
      }
      subtitle={subtitle}
      tooltipText={tooltip}
    />
  )
}

export function MemberReportStatisticCardSkeleton() {
  const classes = useStyles()
  return <StatisticsReportCardSkeleton classes={{ root: classes.card }} />
}

const useStyles = makeUseStyles((theme) => ({
  card: {
    flexGrow: 1,
    border: theme.palette.constants.borderSmall,
    boxShadow: theme.palette.groovyDepths.xs,

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}))
